import FormChangeFileType from './FormChangeFileType';

export default FormChangeFileType;